<template>
  <PageContent class="batch-edit-wrapper">
    <span class="summary-title">
      Please review and confirm your submission
    </span>
    <PanelV2 type="w6" title="Business Information" @nextClick="commitData()" mode="edit">
      <template v-slot:title-solt>
        <!-- <span class="btn-action">EDIT</span> -->
      </template>
      <template v-slot:content-solt>
        <AppForm
          ref="appForm"
          v-model="formData"
          :selectOptions="selectOptions"
        />
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
import AppForm from "../forms/BdoMerchantA.val";
import cityData from "../../common-data/city_select_data";
import API from "@/api";

export default {
  name: "EditBusinessInfo3",
  components: {
    AppForm
  },
  data() {
    return {
      formData: {},
      selectOptions: {
        "city_1": cityData,
      },
    };
  },
  created() {
    API.getBdoProcessData({
      pageNo: "999",
      token: this.getCookieItem("token"),
    }).then((res) => {
      if (res.success) {
        Object.assign(this.formData, res.obj.bdoBusinessDetails);
        this.formData['city_1'] = this.formData.city
        this.formData['businessName_1'] = this.formData.businessName
        this.$refs.appForm.updateDataForm(this.formData);
      }
    });
  },
  methods: {
    commitData() {
      this.$refs.appForm.$refs.appForm.validate((valid) => {
        if (valid) {
          API.addBdoProcess({
            pageNo: "15",
            token: this.getCookieItem("token"),
            bdoBusinessDetails: {...this.formData, city: this.formData['city_1'], businessName: this.formData['businessName_1']}
          }).then((res) => {
            if (res.success === true) {
              window.history.go(-1);
            }
          });
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.panel-v2.content-area {
  margin: 16px 0;
  ::v-deep.content {
    margin-bottom: 160px;
  }
}
.radioBox {
  margin-bottom: 40px;
  .radioTitle {
    margin-bottom: 4px;
    font-size: 16px;
    color: #2e2e2e;
    // font-family: Nunito;
  }
}
.underline {
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 30px;
}
</style>
